import { BaseFieldWidget, DetailM2MTableFieldWidget, ModelFieldType, RelationQueryHelper, ReturnPromise, SPI, TABLE_WIDGET, ViewType } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget: TABLE_WIDGET,
    name: 'retailItemList',
    model: 'deli.retail.BackendRetailCategoryProxy'
  })
)
export class CustomFormM2MTableFieldWidget extends DetailM2MTableFieldWidget {
  protected initSubviewData(): ReturnPromise<void> {
    const view = this.runtimeSubviewContext.view;
    if (!view) {
      super.initSubviewData();
      return;
    }

    const { formData, model, field } = this;
    if (!formData.code) {
      return;
    }

    const queryData = RelationQueryHelper.generatorM2MQueryData(model, field, formData);
    if (!queryData) {
      this.isDataSourceProvider = false;
      this.reloadDataSource([]);
      return;
    }

    if (!this.isDataSourceProvider) {
      this.reloadDataSource(undefined);
    }
    view.initialValue = [queryData];
    console.log('🚀 ~ CustomFormM2MTableFieldWidget ~ initSubviewData ~ queryData:', queryData);
    this.isDataSourceProvider = false;
  }
}
